export const TITULO_ELEITOR = {
  "numeroTitulo": "13344311651",
  "nome": "HVITRL XZIOLH ILXSZ",
  "nomeMae": "QLHVUZ WV EZHXLMXVOLH XZIOLH ILXSZ",
  "dataNascimento": "05121972",
  "codigoSituacao": 0,
  "descricaoSituacao": "REGULAR",
  "dataAtualizacao": "30042025"
};
